export enum AnnotationType {
  ARROW = "arrow",
  RECTANGLE = "rectangle",
  TEXT = "text",
  HIGHLIGHT = "highlight",
  ELLIPSE = "ellipse",
}
